import React from "react";
import DropDown from "./DropDown";
import { DEFAULT_RADIUSES } from "../../helpers/helper";
import { useAppContext } from "../../helpers/account-context";

// https://codepen.io/smithsuth/pen/VvYzZP

const getRadiuses = (accRadiuses, unit) => {
  const radiuses =
    (!accRadiuses || accRadiuses.length === 0)
      ? DEFAULT_RADIUSES
      : accRadiuses.map((x) => ({ label: `${x} ${unit}`, value: x }));
  return radiuses;
};

const RadiusDropdown = (props) => {
  const { filters, onChangeFilters } = props;
  const selectedRadius = filters.radius ? `${filters.radius} ${filters.unit}` : null;
  const { initedData: {hiddenFilters}, account: { radiuses, distance_unit }, getLocale  } = useAppContext();
  const isHidden = !!hiddenFilters && (hiddenFilters.indexOf('radiuses') >= 0 || hiddenFilters.indexOf('all') >= 0);
  if(isHidden) return null;
  
  return (
    <DropDown
      className="cbmap-dropdown-radius"
      title={`${selectedRadius || getLocale("radius")}`}
      items={getRadiuses(radiuses, distance_unit)}
      selectedItems={[filters.radius]}
      isMulti={false}
      isForced={true}
      onChange={(tt) =>
        onChangeFilters({
          ...filters,
          radius: tt && tt.length > 0 ? tt[0] : null,
        })
      }
    />
  )
};

export default RadiusDropdown;
